import { FC } from "react";
import { Skeleton } from "@shadcn/components/ui/skeleton";

export const QuestionSkeleton: FC = () => {
  return (
    <div className="space-y-4">
      <Skeleton className="h-6 w-1/2" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
};
